import React, {useEffect, useState} from "react";
import {useInfoBannerTrial} from "../../../hooks";
import {getInfoBanner} from "../../../selectors/infoBanner";
import {InfoBanner} from "@hapinest/theme";

const TryOutInfoBanner = () => {
    const {componentData} = useInfoBannerTrial();
    const [items, setItems] = useState();

    useEffect(() => {
        if (componentData?.items.length) {
            const data = getInfoBanner(componentData);
            setItems(data);
        }
    }, [componentData]);

    return (
        <>
            {items && (
                <InfoBanner
                    bgColor={items?.bgColor}
                    subtitle={items?.subtitle}
                    title={items?.title}
                    description={items?.description}
                    imageTitle={items?.imageTitle}
                    imageUrl={items?.imageUrl}
                    buttons={items?.buttons}
                />
            )}
        </>

    );
};

export default TryOutInfoBanner;
